import React, { useEffect, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

// FIX_SSR_CAPTCHA — o ReCAPTCHA depende do JS da Google, que não roda em SSR
// (renderToString) nem no iframe do preview/canvas do editor de templates.
// Nesse caso, mostramos um placeholder visual estático. No browser normal
// (fluxo de inscrição), useEffect troca pra widget real.
// Reverter = remover o ternário e voltar ao <ReCAPTCHA .../> direto.
export const CaptchaPlaceholder = () => (
  <div
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 12,
      padding: '10px 14px',
      border: '1px solid #d3d3d3',
      borderRadius: 4,
      background: '#f9f9f9',
      fontFamily: 'Roboto, Arial, sans-serif',
      fontSize: 14,
      color: '#000',
      minWidth: 300,
      minHeight: 74,
      boxSizing: 'border-box',
    }}
  >
    <span
      style={{
        width: 24,
        height: 24,
        border: '2px solid #c1c1c1',
        borderRadius: 2,
        background: '#fff',
        flexShrink: 0,
      }}
    />
    <span style={{ flex: 1 }}>I'm not a robot</span>
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        flexShrink: 0,
      }}
    >
      <img
        src="https://www.gstatic.com/recaptcha/api2/logo_48.png"
        alt="reCAPTCHA"
        width="34"
        height="34"
        style={{ display: 'block' }}
      />
      <span style={{ fontSize: 10, color: '#555' }}>reCAPTCHA</span>
      <span style={{ fontSize: 8, color: '#999' }}>Privacy · Terms</span>
    </div>
  </div>
);

// Cleanup do namespace global do reCAPTCHA. O GoogleReCaptchaProvider (v3)
// injeta um window.grecaptcha sem .clients ao ser montado no /login; esse
// state persiste após navegar pra outras rotas (SPA, mesmo window). Se o
// widget v2 tentar renderizar depois disso, chama grecaptcha.render() que
// itera .clients (undefined) e crasha. Removemos as globais e a <script>
// do v3 pra forçar o wrapper v2 a injetar seu próprio script limpo. Se o
// v2 já foi montado (grecaptcha.clients é array), o cleanup é no-op.
export function cleanupRecaptchaNamespaceIfNeeded() {
  if (typeof window === 'undefined') return;
  try {
    const hasV2Ready = window.grecaptcha && Array.isArray(window.grecaptcha.clients);
    if (hasV2Ready) return;
    delete window.grecaptcha;
    delete window.___grecaptcha_cfg;
    document
      .querySelectorAll('script[src*="recaptcha/api.js?render="]')
      .forEach((s) => s.remove());
  } catch (err) {
    console.warn('[Captcha] Falha no cleanup do reCAPTCHA:', err);
  }
}

export default function Captcha({ rowId, colId, setValue }) {
  const [value, setValueCaptcha] = useState('');
  // ssr = true no primeiro render (browser e SSR). useEffect só executa
  // no browser — vira false só quando temos JS ativo pra carregar o widget.
  const [ssr, setSsr] = useState(true);

  useEffect(() => {
    cleanupRecaptchaNamespaceIfNeeded();
    setSsr(false);
  }, []);

  useEffect(() => {
    setValue((oldValue) => {
      const newValue = [...oldValue];
      newValue[rowId].cols[colId].attributes.value = value;
      if (!value) {
        newValue[rowId].cols[colId].attributes.errorMessage = 'O captcha é obrigatório';
      } else {
        newValue[rowId].cols[colId].attributes.errorMessage = '';
      }
      return newValue;
    });
  }, [value, setValue, rowId, colId]);

  return (
    <div>
      <div className="displayed-config-container">
        <div className="displayed-label">
          {ssr ? (
            <CaptchaPlaceholder />
          ) : (
            <ReCAPTCHA
              sitekey="6Lcj77QUAAAAALq8HRPFs-tEagWfhWqg7AfYJ8JP"
              onChange={(e) => setValueCaptcha(e)}
            />
          )}
        </div>
      </div>
    </div>
  );
}
